// extracted by mini-css-extract-plugin
export default {"paginationWrapper":"PaymentSchedule_paginationWrapper__8X6P-","calendarWrapper":"PaymentSchedule_calendarWrapper__N4bJz","spinnerWrapper":"PaymentSchedule_spinnerWrapper__40rdX"};